import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AlertSection from '../alert-section/alert-section.component'

const SuspendedAlert = ({ suspendedDate: _suspendedDate }) => {
  const { t } = useTranslation(['checkIn'])

  return (
    <AlertSection
      type="suspended"
      title={t('checkIn:suspendedClient')}
      description={t('checkIn:noActivePackage')}
    />
  )
}

SuspendedAlert.propTypes = {
  suspendedDate: PropTypes.string,
}

export default SuspendedAlert
